import React from 'react';
import { Input } from '@common/FormFields';
import { ConvoyVisualization } from './ConvoyVisualization';

export const ConvoySpecsForm = ({ specs, onChange, disabled = false }) => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-7 gap-y-2 md:-mx-1">
        <Input
          label="Vehicle Width (m)"
          type="number"
          min="0"
          step="0.1"
          value={specs.width || 2.6}
          onChange={(e) => onChange({ ...specs, width: Number(e.target.value) })}
          disabled={disabled}
          className="border-gray-600 text-white w-[110px] md:mx-1"
          labelClassName="text-gray-300 whitespace-nowrap text-xs"
          title="Vehicle width for turning radius calculation"
        />
        <Input
          label="Total Length (m)"
          type="number"
          min="0"
          step="0.1"
          value={specs.length}
          onChange={(e) => onChange({ ...specs, length: Number(e.target.value) })}
          disabled={disabled}
          className="border-gray-600 text-white w-[110px] md:mx-1"
          labelClassName="text-gray-300 whitespace-nowrap text-xs"
        />
        <Input
          label="Load Clearance (m)"
          type="number"
          min="0"
          step="0.01"
          value={specs.clearance}
          onChange={(e) => onChange({ ...specs, clearance: Number(e.target.value) })}
          disabled={disabled}
          className="border-gray-600 text-white w-[110px] md:mx-1"
          labelClassName="text-gray-300 whitespace-nowrap text-xs"
        />
        <Input
          label="Axle Spacing (m)"
          type="number"
          min="0"
          step="0.1"
          value={specs.axleSpacing}
          onChange={(e) => onChange({ ...specs, axleSpacing: Number(e.target.value) })}
          disabled={disabled}
          className="border-gray-600 text-white w-[110px] md:mx-1"
          labelClassName="text-gray-300 whitespace-nowrap text-xs"
        />
        <Input
          label="Rear Contact (m)"
          type="number"
          min="0"
          step="0.1"
          value={specs.rearContact}
          onChange={(e) => onChange({ ...specs, rearContact: Number(e.target.value) })}
          disabled={disabled}
          className="border-gray-600 text-white w-[110px] md:mx-1"
          labelClassName="text-gray-300 whitespace-nowrap text-xs"
          title="Length of rear ground contact"
        />
        <Input
          label="Rear Height (m)"
          type="number"
          min="0"
          step="0.01"
          value={specs.rearHeight}
          onChange={(e) => onChange({ ...specs, rearHeight: Number(e.target.value) })}
          disabled={disabled}
          className="border-gray-600 text-white w-[110px] md:mx-1"
          labelClassName="text-gray-300 whitespace-nowrap text-xs"
          title="Height at rear overhang"
        />
        <Input
          label="Convoy Speed (km/h)"
          type="number"
          min="0"
          max="120"
          value={specs.speed}
          onChange={(e) => onChange({ ...specs, speed: Number(e.target.value) })}
          disabled={disabled}
          className="border-gray-600 text-white w-[110px] md:mx-1"
          labelClassName="text-gray-300 whitespace-nowrap text-xs"
        />
        <div className="md:mx-1">
          <label className="block text-xs font-medium text-gray-300 whitespace-nowrap mb-1">
            Suspension Type
          </label>
          <select
            value={specs.suspension}
            onChange={(e) => onChange({ ...specs, suspension: e.target.value })}
            disabled={disabled}
            className="w-[110px] border border-gray-600 rounded px-3 py-2 text-white bg-transparent"
          >
            <option value="air">Air Suspension</option>
            <option value="leaf">Leaf Spring</option>
            <option value="hydraulic">Hydraulic</option>
          </select>
        </div>
      </div>


      {/* Add Convoy Visualization */}
      <div className="mt-6">
        <h3 className="text-sm font-medium text-gray-300 mb-3">Clearance Analysis</h3>
        <ConvoyVisualization specs={specs} />
      </div>
    </div>
  );
};